export var appVersion = '1.0.98'